module.exports = __webpack_public_path__ + "img/gywm03.33a29a01.png";